import {
  SelectedDynamicFilterModel,
  PriceRange,
  getCatalogFiltersFacets,
} from '@marketplace-web/catalog/catalog-data'
import {
  useCatalogContext,
  DynamicFilterReducerAction,
} from '@marketplace-web/catalog/catalog-page-data'

type FetchDynamicFiltersFacetsParams = {
  selectedDynamicFilters: Array<SelectedDynamicFilterModel>
  selectedTemporaryCatalogIds?: Array<number>
  selectedTemporaryPriceRange?: PriceRange
  filterCode: string
}

const useFetchDynamicFiltersFacets = () => {
  const { state, dispatch } = useCatalogContext()

  const fetchDynamicFilterFacets = async ({
    selectedDynamicFilters,
    selectedTemporaryCatalogIds,
    selectedTemporaryPriceRange,
    filterCode,
  }: FetchDynamicFiltersFacetsParams) => {
    const { filters } = state

    dispatch({
      type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_REQUEST,
      payload: undefined,
    })

    const currentCatalogIds = selectedTemporaryCatalogIds ?? filters.catalogIds
    const currentPriceRange = selectedTemporaryPriceRange ?? {
      priceFrom: filters.priceFrom,
      priceTo: filters.priceTo,
    }

    const response = await getCatalogFiltersFacets({
      ...filters,
      selectedDynamicFilters,
      catalogIds: currentCatalogIds,
      priceFrom: currentPriceRange.priceFrom,
      priceTo: currentPriceRange.priceTo,
      filterCode,
    })

    if ('errors' in response) {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_FAILURE,
        payload: { errors: response.errors },
      })
    } else {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_SUCCESS,
        payload: {
          totalCount: response.total_count,
          totalCountMax: response.total_count_max,
        },
      })
    }
  }

  return fetchDynamicFilterFacets
}

export default useFetchDynamicFiltersFacets
